var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.77 14.16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "search")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.44,13.81a1.14,1.14,0,0,1-1.6,0l0,0-3-3.08a.1.1,0,0,1,0-.05,5.52,5.52,0,0,1-3.12,1A5.75,5.75,0,0,1,0,5.82,5.75,5.75,0,0,1,5.66,0a5.75,5.75,0,0,1,5.67,5.82A5.92,5.92,0,0,1,10.39,9l.06,0,3,3.08A1.2,1.2,0,0,1,13.44,13.81Zm-4.08-8A3.75,3.75,0,0,0,5.66,2,3.75,3.75,0,0,0,2,5.82a3.75,3.75,0,0,0,3.7,3.8,3.75,3.75,0,0,0,3.7-3.8Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.03621f09.svg";
export { ForwardRef as ReactComponent };